import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {formatResetTime} from '../../../services/rule-test/rule-test.format';

/**
 * Bis zu so vielen Läufen ein Segment je Lauf (Figma: 5). Seit das Limit im Admin Center je Nutzer
 * frei wählbar ist (bis 1000), darüber ein durchgehender Balken.
 */
export const MAX_SEGMENTS = 10;

/**
 * Kontingent als Segmentbalken (Figma „Prüfregel testen", Footer): `limit` Segmente, links die noch
 * verfügbaren in Grün, rechts die verbrauchten in Grau. Optional mit dem Text
 * „{remaining} von {limit} Testläufen heute verfügbar · erneuert sich um 00:00 Uhr".
 * Limit 0 heißt: für dieses Konto im Admin Center gesperrt – dann nur der Hinweis, ohne Balken.
 */
@Component({
  selector: 'app-quota-segments',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './quota-segments.component.html',
})
export class QuotaSegmentsComponent implements OnChanges {
  @Input() limit = 0;
  @Input() used = 0;
  /** `RuleTestQuota.resetsAt` – nur für den Text. */
  @Input() resetsAt: string | null = null;
  /** Text neben den Segmenten anzeigen. */
  @Input() showText = true;

  /** Je Segment: verfügbar (`true`) oder verbraucht. Als Feld, damit `@for` stabil bleibt. */
  segments: boolean[] = [];
  remaining = 0;
  /** Anteil der verfügbaren Läufe für den durchgehenden Balken (über {@link MAX_SEGMENTS}). */
  remainingPercent = 0;
  text = '';

  ngOnChanges(): void {
    const limit = Math.max(0, Math.floor(this.limit || 0));
    this.remaining = Math.min(limit, Math.max(0, limit - Math.max(0, this.used || 0)));
    this.segments = limit <= MAX_SEGMENTS
      ? Array.from({length: limit}, (_, index) => index < this.remaining)
      : [];
    this.remainingPercent = limit > 0 ? (this.remaining / limit) * 100 : 0;
    if (limit === 0) {
      this.text = 'Für dein Konto sind derzeit keine Testläufe freigeschaltet';
      return;
    }
    const noun = limit === 1 ? 'Testlauf' : 'Testläufen';
    this.text = `${this.remaining} von ${limit} ${noun} heute verfügbar · erneuert sich um ${formatResetTime(this.resetsAt)}`;
  }
}
